import { combinarFechaConHoraActual, toLocalISOString } from '../../../utils/horaLocal';

/**
 * Resuelve la fecha de registro para ventas/compras.
 * Acepta YYYY-MM-DD (combina con hora actual) o ISO completo.
 */
export function resolveFechaRegistro(fechaInput, horaBase = new Date()) {
  const raw = String(fechaInput || '').trim();
  if (!raw) return toLocalISOString(horaBase);
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    return combinarFechaConHoraActual(raw, horaBase);
  }
  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) {
    return toLocalISOString(parsed);
  }
  return toLocalISOString(horaBase);
}
